import classNames from "classnames"

import { useTranslation } from "@bounce/i18n"
import { App } from "@bounce/util"
import { AppBanner as BaseAppBanner } from "@bounce/web-components"

import { useAppStoreUrl } from "../../../hooks/useAppStoreUrl"

import illustration from "./assets/illustration.png"

export type AppBannerProps = {
  id?: string
  name?: string
  className?: string
}

export const AppBanner = ({ id, name, className }: AppBannerProps) => {
  const { t } = useTranslation("marketing-pa")
  const { href, onClick } = useAppStoreUrl({
    app: App.Packages,
    eventProps: { location: "AppBannerPackages", cta: name },
  })

  return (
    <BaseAppBanner
      id={id}
      title={t("cmp.appBannerPackages.title", "Get the Bounce package app")}
      subtitle={t(
        "cmp.appBannerPackages.subtitle",
        "Instantly find hundreds of locations to receive your package. Get notified once your package arrives to your location.",
      )}
      ctaHref={href}
      ctaOnClick={onClick}
      src={illustration}
      ctaRel="nofollow"
      ctaLabel={t("cmp.appBannerPackages.cta", "Download")}
      className={classNames(className, "relative")}
      imageClassName="sm:absolute bottom-0 right-0 !p-0"
    />
  )
}
